// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from TabBar-ButtonTitle.module.scss  */
.TabBar-ButtonTitle-module-Root_3Ob {
  overflow: hidden;
  max-width: 100%;
  margin-top: -4px;
  text-overflow: ellipsis;
  color: var(--tab-bar-text-color); }
  .TabBar-ButtonTitle-module-Root_3Ob.TabBar-ButtonTitle-module-active_2KL {
    color: var(--tab-bar-active-text-color); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/TabBar/ButtonTitle/TabBar-ButtonTitle.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC,EAAE;EAClC;IACE,uCAAuC,EAAE","sourcesContent":["/*  imported from TabBar-ButtonTitle.module.scss  */\n.TabBar-ButtonTitle-module-Root_3Ob {\n  overflow: hidden;\n  max-width: 100%;\n  margin-top: -4px;\n  text-overflow: ellipsis;\n  color: var(--tab-bar-text-color); }\n  .TabBar-ButtonTitle-module-Root_3Ob.TabBar-ButtonTitle-module-active_2KL {\n    color: var(--tab-bar-active-text-color); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
